/**
 * @generated SignedSource<<bcdc8a72af03526453b8cf92280466de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationCenter_MarkAllAsReadMutation$variables = {};
export type NotificationCenter_MarkAllAsReadMutation$data = {
  readonly NotificationCenter_MarkAllAsRead: {
    readonly notificationCenter: {
      readonly id: string;
      readonly otherNotificationCount: number;
      readonly unreadNotificationCount: number;
      readonly " $fragmentSpreads": FragmentRefs<"NotificationCenter_List">;
    };
  } | null;
};
export type NotificationCenter_MarkAllAsReadMutation = {
  response: NotificationCenter_MarkAllAsReadMutation$data;
  variables: NotificationCenter_MarkAllAsReadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadNotificationCount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "otherNotificationCount",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = [
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationCenter_MarkAllAsReadMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarkAllNotificationsAsRead",
        "kind": "LinkedField",
        "name": "NotificationCenter_MarkAllAsRead",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationCenter",
            "kind": "LinkedField",
            "name": "notificationCenter",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NotificationCenter_List"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NotificationCenter_MarkAllAsReadMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarkAllNotificationsAsRead",
        "kind": "LinkedField",
        "name": "NotificationCenter_MarkAllAsRead",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NotificationCenter",
            "kind": "LinkedField",
            "name": "notificationCenter",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "NotificationCenterConnection",
                "kind": "LinkedField",
                "name": "notifications",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NotificationCenterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursorBefore",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NotificationCenterEntry",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v0/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "verb",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "outerObject",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v0/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "title",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Account",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "eventTitle",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Note",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "title",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayName",
                                    "storageKey": null
                                  }
                                ],
                                "type": "NoteStream",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v6/*: any*/),
                                "type": "FeedbackNode",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v6/*: any*/),
                                "type": "CommentThread",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v6/*: any*/),
                                "type": "Objective",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "unread",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subtitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "body",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "notifications(first:20)"
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "NotificationCenter_notifications",
                "kind": "LinkedHandle",
                "name": "notifications"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0a7c63feac59ec36a99a7f403573e187",
    "id": null,
    "metadata": {},
    "name": "NotificationCenter_MarkAllAsReadMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationCenter_MarkAllAsReadMutation {\n  NotificationCenter_MarkAllAsRead {\n    notificationCenter {\n      id\n      unreadNotificationCount\n      otherNotificationCount\n      ...NotificationCenter_List\n    }\n  }\n}\n\nfragment NotificationCenter_List on NotificationCenter {\n  notifications(first: 20) {\n    edges {\n      cursorBefore\n      node {\n        id\n        verb\n        outerObject {\n          __typename\n          id\n        }\n        ...NotificationCenter_Notification\n        ...NotificationCenter_squashEditedNoteNotificationsNotification\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n  id\n}\n\nfragment NotificationCenter_Notification on NotificationCenterEntry {\n  id\n  unread\n  createdAt\n  title\n  subtitle\n  body\n  url\n  verb\n  outerObject {\n    __typename\n    ... on Account {\n      id\n      title: name\n    }\n    ... on Note {\n      id\n      title\n      eventTitle\n    }\n    ... on NoteStream {\n      id\n      title: displayName\n    }\n    ... on FeedbackNode {\n      id\n      title\n    }\n    ... on CommentThread {\n      id\n      title\n    }\n    ... on Objective {\n      id\n      title\n    }\n    id\n  }\n}\n\nfragment NotificationCenter_squashEditedNoteNotificationsNotification on NotificationCenterEntry {\n  id\n  verb\n  unread\n  url\n  createdAt\n  outerObject {\n    __typename\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d00fd2c6096b14038871a1c61fa17622";

export default node;
